/* Load Modules */
import { memoize } from "lodash";

/* Load Constants */
import {
    checkRenderForProvider,
    checkDefaultForType,
    getNewGeneratedId,
    uuidv4
} from "../../../../../../../utils/utils";

export const defaultMrChampion = memoize(({ schema, mrChampionConfig }) => {
    let defaults = {};
    defaults["type"] = "mr_champion";
    defaults["terminal_groups"] = [];
    defaults["id"] = getNewGeneratedId("MrChampion", mrChampionConfig);
    defaults["uuid"] = uuidv4();

    Object.keys(schema.properties).map(item => {
        if (item !== "uuid") {
            defaults[item] =
                checkRenderForProvider(item, schema.properties) &&
                schema.properties[item]
                    ? schema.properties[item].hasOwnProperty("default")
                        ? schema.properties[item].convert
                            ? schema.properties[item].default / 100
                            : schema.properties[item].default
                        : checkDefaultForType(schema.properties[item].type)
                    : null;
        }
    });

    return defaults;
});

export const defaultPigBoom = memoize(({ schema, pigBoomConfig }) => {
    let defaults = {};
    defaults["type"] = "pig_boom";
    defaults["terminal_groups"] = [];
    defaults["id"] = getNewGeneratedId("PigBoom", pigBoomConfig);
    defaults["uuid"] = uuidv4();

    Object.keys(schema.properties).map(item => {
        if (item !== "uuid") {
            defaults[item] =
                checkRenderForProvider(item, schema.properties) &&
                schema.properties[item]
                    ? schema.properties[item].hasOwnProperty("default")
                        ? schema.properties[item].convert
                            ? schema.properties[item].default / 100
                            : schema.properties[item].default
                        : checkDefaultForType(schema.properties[item].type)
                    : null;
        }
    });

    return defaults;
});
